import api from "../config";
import URLS from "../../constants/urls";
export const _getCategoriessBySiteID = async (siteId, pageNumber, pageSize) => {
    const response = await api.get(`${URLS.CATEGORY}/${siteId}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
    return response.data;
};
export const _createCategory = async (data) => {
    const response = await api.post(`${URLS.CATEGORY}/create`, data);
    return response.data;
};
export const _updateCategory = async (siteId, categoryId, data) => {
    const response = await api.put(`${URLS.CATEGORY}/${siteId}/${categoryId}`, data);
    return response.data;
};
export const _deleteCategory = async (siteId, categoryId) => {
    const response = await api.delete(`${URLS.CATEGORY}/${siteId}/${categoryId}`);
    return response.data;
};
export const _getCategoriesIcon = async () => {
    const response = await api.get(URLS.ICONS);
    return response?.data;
};
